module.exports = __webpack_public_path__ + "static/media/backgroundImage2.7897cea6.svg";